module.exports = __webpack_public_path__ + "static/home-b1bdda7b141b097551131708164d3ec1.mp4";